<template>
    <div class="form-edit-page">
        <div class="page-header">
            <div>
                <h2>Cadastro de Rótulos</h2>
                <p class="page-subtitle">
                    Controle de processos de registro, alteração, renovação e cancelamento de rótulos por estabelecimento/produto.
                </p>
            </div>
        </div>

        <!-- FORMULÁRIO -->
        <div class="form-card">
            <div class="form-section-title">Dados do Processo de Rótulo</div>

            <div class="row">
                <div class="field field-40">
                    <label>Estabelecimento</label>
                    <select v-model="objEdicao.idEstabelecimento">
                        <option :value="null">Selecione</option>
                        <option v-for="item in lsEstabelecimentos" :key="item.id" :value="item.id">
                            {{ item.nome }}
                        </option>
                    </select>
                </div>

                <div class="field field-40">
                    <label>Produto</label>
                    <select v-model="objEdicao.idProduto">
                        <option :value="null">Selecione</option>
                        <option v-for="item in lsProdutosFiltrados" :key="item.id" :value="item.id">
                            {{ item.nome }}
                        </option>
                    </select>
                </div>

                <div class="field field-20">
                    <label>Tipo de Processo</label>
                    <select v-model="objEdicao.tipoProcesso">
                        <option value="">Selecione</option>
                        <option value="REGISTRO">Registro</option>
                        <option value="ALTERACAO">Alteração</option>
                        <option value="RENOVACAO">Renovação</option>
                        <option value="CANCELAMENTO">Cancelamento</option>
                        <option value="SUBSTITUICAO">Substituição</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="field field-25">
                    <label>Nº do Processo</label>
                    <input v-model="objEdicao.nrProcesso" type="text" maxlength="30" placeholder="Ex: ROT-2026-0001" />
                </div>

                <div class="field field-25">
                    <label>Nº do Registro</label>
                    <input v-model="objEdicao.nrRegistro" type="text" maxlength="30" placeholder="Ex: SIM-ROT-145" />
                </div>

                <div class="field field-30">
                    <label>Nome de Apresentação no Rótulo</label>
                    <input v-model="objEdicao.nmRotulo" type="text" maxlength="120" />
                </div>

                <div class="field field-20">
                    <label>Versão do Rótulo</label>
                    <input v-model="objEdicao.versaoRotulo" type="text" maxlength="20" placeholder="Ex: 01" />
                </div>
            </div>

            <div class="row">
                <div class="field field-20">
                    <label>Data da Solicitação</label>
                    <input v-model="objEdicao.dtSolicitacao" type="date" />
                </div>

                <div class="field field-20">
                    <label>Data da Análise</label>
                    <input v-model="objEdicao.dtAnalise" type="date" />
                </div>

                <div class="field field-20">
                    <label>Situação</label>
                    <select v-model="objEdicao.situacao">
                        <option value="">Selecione</option>
                        <option value="EM_ANALISE">Em análise</option>
                        <option value="APROVADO">Aprovado</option>
                        <option value="PENDENTE">Pendente</option>
                        <option value="INDEFERIDO">Indeferido</option>
                        <option value="CANCELADO">Cancelado</option>
                    </select>
                </div>

                <div class="field field-20">
                    <label>Data da Situação</label>
                    <input v-model="objEdicao.dtSituacao" type="date" />
                </div>

                <div class="field field-20">
                    <label>Responsável</label>
                    <input v-model="objEdicao.responsavel" type="text" maxlength="60" />
                </div>
            </div>

            <div class="row">
                <div class="field field-100">
                    <label>Motivo / Descrição da Solicitação</label>
                    <textarea
                        v-model="objEdicao.dsSolicitacao"
                        rows="3"
                        placeholder="Descreva o objetivo do processo: registro inicial, alteração de layout, atualização de composição, cancelamento do rótulo, etc."
                    />
                </div>
            </div>

            <div class="row">
                <div class="field field-50">
                    <label>Pendências / Exigências</label>
                    <textarea
                        v-model="objEdicao.dsPendencias"
                        rows="3"
                        placeholder="Ex: ajustar composição, corrigir denominação de venda, revisar informação nutricional..."
                    />
                </div>

                <div class="field field-50">
                    <label>Observações Internas</label>
                    <textarea
                        v-model="objEdicao.obsInterna"
                        rows="3"
                        placeholder="Observações do fiscal / histórico resumido do andamento."
                    />
                </div>
            </div>

            <div class="form-actions">
                <button class="btn btn-primary" @click="adicionarItem">Adicionar na lista</button>
                <button class="btn btn-secondary" @click="limparFormulario">Limpar</button>
            </div>
        </div>

        <!-- FILTROS -->
        <div class="list-card">
            <div class="list-header">
                <div>
                    <div class="form-section-title">Lista de Processos de Rótulos</div>
                    <div class="list-subtitle">Visualização conceito para a POC</div>
                </div>

                <div class="list-filters">
                    <input
                        v-model="filtroTexto"
                        type="text"
                        placeholder="Pesquisar estabelecimento, produto, processo..."
                    />

                    <select v-model="filtroSituacao">
                        <option value="">Todas as situações</option>
                        <option value="EM_ANALISE">Em análise</option>
                        <option value="APROVADO">Aprovado</option>
                        <option value="PENDENTE">Pendente</option>
                        <option value="INDEFERIDO">Indeferido</option>
                        <option value="CANCELADO">Cancelado</option>
                    </select>
                </div>
            </div>

            <div class="table-wrap">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Processo</th>
                            <th>Estabelecimento</th>
                            <th>Produto</th>
                            <th>Tipo</th>
                            <th>Rótulo</th>
                            <th>Versão</th>
                            <th>Situação</th>
                            <th>Solicitação</th>
                            <th>Responsável</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in lsDadosFiltrados" :key="item.id" @click="carregarItem(item)" class="row-clickable">
                            <td>{{ item.nrProcesso }}</td>
                            <td>{{ item.nmEstabelecimento }}</td>
                            <td>{{ item.nmProduto }}</td>
                            <td>{{ item.tipoProcesso }}</td>
                            <td>{{ item.nmRotulo }}</td>
                            <td>{{ item.versaoRotulo }}</td>
                            <td>
                                <span class="status-badge" :class="getStatusClass(item.situacao)">
                                    {{ formatarSituacao(item.situacao) }}
                                </span>
                            </td>
                            <td>{{ formatarData(item.dtSolicitacao) }}</td>
                            <td>{{ item.responsavel }}</td>
                        </tr>

                        <tr v-if="lsDadosFiltrados.length === 0">
                            <td colspan="9" class="empty-state">
                                Nenhum processo de rótulo encontrado.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue';

const novoObjeto = () => ({
    id: 0,
    idEstabelecimento: null,
    idProduto: null,
    tipoProcesso: '',
    nrProcesso: '',
    nrRegistro: '',
    nmRotulo: '',
    versaoRotulo: '01',
    dtSolicitacao: '',
    dtAnalise: '',
    situacao: 'EM_ANALISE',
    dtSituacao: '',
    responsavel: '',
    dsSolicitacao: '',
    dsPendencias: '',
    obsInterna: '',
});

const objEdicao = reactive(novoObjeto());
const filtroTexto = ref('');
const filtroSituacao = ref('');

const lsEstabelecimentos = ref([
    { id: 1, nome: 'Frigorífico Vale do Rio' },
    { id: 2, nome: 'Laticínios Serra Bela' },
    { id: 3, nome: 'Apiário Mel do Campo' },
]);

const lsProdutos = ref([
    { id: 1, idEstabelecimento: 1, nome: 'Linguiça Toscana' },
    { id: 2, idEstabelecimento: 1, nome: 'Salame Colonial' },
    { id: 3, idEstabelecimento: 2, nome: 'Queijo Colonial' },
    { id: 4, idEstabelecimento: 2, nome: 'Iogurte Integral' },
    { id: 5, idEstabelecimento: 3, nome: 'Mel Silvestre 500g' },
]);

const lsDados = ref([
    {
        id: 1,
        idEstabelecimento: 1,
        nmEstabelecimento: 'Frigorífico Vale do Rio',
        idProduto: 1,
        nmProduto: 'Linguiça Toscana',
        tipoProcesso: 'REGISTRO',
        nrProcesso: 'ROT-2026-0001',
        nrRegistro: 'SIM-ROT-001',
        nmRotulo: 'Linguiça Toscana Defumada',
        versaoRotulo: '01',
        dtSolicitacao: '2026-03-01',
        dtAnalise: '2026-03-03',
        situacao: 'APROVADO',
        dtSituacao: '2026-03-05',
        responsavel: 'Carlos Mendes',
        dsSolicitacao: 'Registro inicial de rótulo.',
        dsPendencias: '',
        obsInterna: 'Aprovado sem ressalvas.',
    },
    {
        id: 2,
        idEstabelecimento: 2,
        nmEstabelecimento: 'Laticínios Serra Bela',
        idProduto: 3,
        nmProduto: 'Queijo Colonial',
        tipoProcesso: 'ALTERACAO',
        nrProcesso: 'ROT-2026-0002',
        nrRegistro: 'SIM-ROT-014',
        nmRotulo: 'Queijo Colonial Premium',
        versaoRotulo: '03',
        dtSolicitacao: '2026-03-07',
        dtAnalise: '2026-03-10',
        situacao: 'PENDENTE',
        dtSituacao: '2026-03-10',
        responsavel: 'Mariana Souza',
        dsSolicitacao: 'Alteração de layout e ajuste de composição.',
        dsPendencias: 'Corrigir tabela nutricional.',
        obsInterna: '',
    },
    {
        id: 3,
        idEstabelecimento: 3,
        nmEstabelecimento: 'Apiário Mel do Campo',
        idProduto: 5,
        nmProduto: 'Mel Silvestre 500g',
        tipoProcesso: 'CANCELAMENTO',
        nrProcesso: 'ROT-2026-0003',
        nrRegistro: 'SIM-ROT-022',
        nmRotulo: 'Mel Silvestre Tradicional',
        versaoRotulo: '02',
        dtSolicitacao: '2026-03-11',
        dtAnalise: '',
        situacao: 'EM_ANALISE',
        dtSituacao: '2026-03-11',
        responsavel: 'Fernanda Lima',
        dsSolicitacao: 'Solicitação de cancelamento do rótulo.',
        dsPendencias: '',
        obsInterna: 'Aguardando análise documental.',
    },
]);

const lsProdutosFiltrados = computed(() => {
    if (!objEdicao.idEstabelecimento) return [];
    return lsProdutos.value.filter(a => a.idEstabelecimento === objEdicao.idEstabelecimento);
});

const lsDadosFiltrados = computed(() => {
    return lsDados.value.filter(item => {
        const texto = filtroTexto.value.toLowerCase().trim();

        const atendeTexto =
            !texto ||
            item.nrProcesso.toLowerCase().includes(texto) ||
            item.nmEstabelecimento.toLowerCase().includes(texto) ||
            item.nmProduto.toLowerCase().includes(texto) ||
            item.nmRotulo.toLowerCase().includes(texto) ||
            item.tipoProcesso.toLowerCase().includes(texto);

        const atendeSituacao =
            !filtroSituacao.value || item.situacao === filtroSituacao.value;

        return atendeTexto && atendeSituacao;
    });
});

watch(() => objEdicao.idEstabelecimento, () => {
    objEdicao.idProduto = null;
});

function adicionarItem() {
    if (!objEdicao.idEstabelecimento) {
        alert('Informe o estabelecimento.');
        return;
    }

    if (!objEdicao.idProduto) {
        alert('Informe o produto.');
        return;
    }

    if (!objEdicao.tipoProcesso) {
        alert('Informe o tipo de processo.');
        return;
    }

    if (!objEdicao.nrProcesso) {
        alert('Informe o número do processo.');
        return;
    }

    const estabelecimento = lsEstabelecimentos.value.find(a => a.id === objEdicao.idEstabelecimento);
    const produto = lsProdutos.value.find(a => a.id === objEdicao.idProduto);

    lsDados.value.unshift({
        id: Date.now(),
        idEstabelecimento: objEdicao.idEstabelecimento,
        nmEstabelecimento: estabelecimento?.nome || '',
        idProduto: objEdicao.idProduto,
        nmProduto: produto?.nome || '',
        tipoProcesso: objEdicao.tipoProcesso,
        nrProcesso: objEdicao.nrProcesso,
        nrRegistro: objEdicao.nrRegistro,
        nmRotulo: objEdicao.nmRotulo,
        versaoRotulo: objEdicao.versaoRotulo,
        dtSolicitacao: objEdicao.dtSolicitacao,
        dtAnalise: objEdicao.dtAnalise,
        situacao: objEdicao.situacao,
        dtSituacao: objEdicao.dtSituacao,
        responsavel: objEdicao.responsavel,
        dsSolicitacao: objEdicao.dsSolicitacao,
        dsPendencias: objEdicao.dsPendencias,
        obsInterna: objEdicao.obsInterna,
    });

    limparFormulario();
}

function carregarItem(item) {
    Object.assign(objEdicao, {
        id: item.id,
        idEstabelecimento: item.idEstabelecimento,
        idProduto: item.idProduto,
        tipoProcesso: item.tipoProcesso,
        nrProcesso: item.nrProcesso,
        nrRegistro: item.nrRegistro,
        nmRotulo: item.nmRotulo,
        versaoRotulo: item.versaoRotulo,
        dtSolicitacao: item.dtSolicitacao,
        dtAnalise: item.dtAnalise,
        situacao: item.situacao,
        dtSituacao: item.dtSituacao,
        responsavel: item.responsavel,
        dsSolicitacao: item.dsSolicitacao,
        dsPendencias: item.dsPendencias,
        obsInterna: item.obsInterna,
    });
}

function limparFormulario() {
    Object.assign(objEdicao, novoObjeto());
}

function formatarSituacao(situacao) {
    const mapa = {
        EM_ANALISE: 'Em análise',
        APROVADO: 'Aprovado',
        PENDENTE: 'Pendente',
        INDEFERIDO: 'Indeferido',
        CANCELADO: 'Cancelado',
    };
    return mapa[situacao] || situacao;
}

function formatarData(data) {
    if (!data) return '';
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
}

function getStatusClass(situacao) {
    if (situacao === 'APROVADO') return 'status-ok';
    if (situacao === 'PENDENTE') return 'status-warn';
    if (situacao === 'INDEFERIDO' || situacao === 'CANCELADO') return 'status-error';
    return 'status-info';
}
</script>

<style scoped>
.form-edit-page {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background: #f5f7fb;
}

.page-header h2 {
    margin: 0;
    font-size: 24px;
    color: #1f2937;
}

.page-subtitle {
    margin: 6px 0 0 0;
    color: #6b7280;
    font-size: 14px;
}

.form-card,
.list-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 16px;
}

.form-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 14px;
}

.row {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.field label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}

.field input,
.field select,
.field textarea {
    width: 100%;
    min-height: 38px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 14px;
    box-sizing: border-box;
    background: #fff;
}

.field textarea {
    min-height: 80px;
    resize: vertical;
}

.field-20 { flex: 1 1 calc(20% - 12px); }
.field-25 { flex: 1 1 calc(25% - 12px); }
.field-30 { flex: 1 1 calc(30% - 12px); }
.field-40 { flex: 1 1 calc(40% - 12px); }
.field-50 { flex: 1 1 calc(50% - 12px); }
.field-100 { flex: 1 1 100%; }

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 8px;
}

.btn {
    border: none;
    border-radius: 8px;
    padding: 10px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
}

.btn-primary {
    background: #2563eb;
    color: #fff;
}

.btn-secondary {
    background: #e5e7eb;
    color: #111827;
}

.list-header {
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 12px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.list-subtitle {
    font-size: 13px;
    color: #6b7280;
    margin-top: 4px;
}

.list-filters {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.list-filters input,
.list-filters select {
    min-width: 220px;
    min-height: 38px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 14px;
}

.table-wrap {
    overflow-x: auto;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.data-table th {
    background: #f3f4f6;
    color: #374151;
    text-align: left;
    padding: 10px;
    border-bottom: 1px solid #e5e7eb;
}

.data-table td {
    padding: 10px;
    border-bottom: 1px solid #eef0f3;
    color: #111827;
    vertical-align: top;
}

.row-clickable {
    cursor: pointer;
}

.row-clickable:hover {
    background: #f9fafb;
}

.status-badge {
    display: inline-block;
    padding: 4px 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.status-ok {
    background: #dcfce7;
    color: #166534;
}

.status-warn {
    background: #fef3c7;
    color: #92400e;
}

.status-error {
    background: #fee2e2;
    color: #991b1b;
}

.status-info {
    background: #dbeafe;
    color: #1d4ed8;
}

.empty-state {
    text-align: center;
    color: #6b7280;
    padding: 20px !important;
}

@media (max-width: 900px) {
    .field-20,
    .field-25,
    .field-30,
    .field-40,
    .field-50 {
        flex: 1 1 100%;
    }
}
</style>